import {Typography} from "@material-tailwind/react";
import persianNumberFormat from "../../../helper/PersianNumberFormat";
import React, {useState} from "react";
import {TableHead} from "../../system/thead";


const TABLE_HEAD = [
  "#",
  "زمان",
  "سرویس",
  "رشته",
  "گرایش",
  "مبلغ",
  "سهم پلتفرم",
  "ارزش افزوده",
  "سهم مباشر",
  "کاربر",
  "مباشر",
  "کدملی کاربر"
];

export function SiteIncomeReportGrid({
                                       siteIncomeReport,
                                       setSortBy,
                                       sortType,
                                       setSortType
                                     }) {
  const avatar = '/assets/blank_profile.jpg';

  const [selectedHead, setSelectedHead] = useState("#")

  const headMap = {
    "#": "",
    "مباشر": "agent_name",
    "کاربر": "person_name",
    "کدملی کاربر": "person_national_code",
    "مبلغ": "total_price",
    "سهم پلتفرم": "site_share",
    "ارزش افزوده": "vat_share",
    "سهم مباشر": "agent_share",
    "سرویس": "type",
    "رشته": "field_title",
    "گرایش": "branch_title",
    "زمان": "created_at",
  }

  const headSortable = {
    "#": "",
    "مباشر": true,
    "کاربر": true,
    "کدملی کاربر": true,
    "مبلغ": true,
    "سهم پلتفرم": true,
    "ارزش افزوده": true,
    "سهم مباشر": true,
    "سرویس": true,
    "رشته": true,
    "گرایش": true,
    "زمان": true,
  }

  return (
    <div>
      <table className="mt-4 text-left w-full">
        <TableHead
          tableHead={TABLE_HEAD}
          headSortable={headSortable}
          headMap={headMap}
          sortType={sortType}
          setSortType={setSortType}
          setSortBy={setSortBy}
          selectedHead={selectedHead}
          setSelectedHead={setSelectedHead}
        />
        <tbody className="textCenter">
        {siteIncomeReport.map(
          ({
             id,
             agent_name,
             agent_phone,
             person_name,
             person_phone,
             person_national_code,
             total_price,
             site_share,
             vat_share,
             agent_share,
             type,
             field_title,
             branch_title,
             created_at,
           }, index) => {
            const isLast = index === siteIncomeReport.length - 1;
            const classes = isLast ? "p-4" : "p-4 border-b border-blue-gray-50";

            return (
              <tr key={id}>

                <td className={classes}>
                  <div className="flex justify-center">
                    <Typography color="blue-gray">
                      {persianNumberFormat(index + 1, true)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex flex-col justify-center px-4">
                    <Typography color="blue-gray">
                      {persianNumberFormat(created_at.split(" ")[0])}
                    </Typography>
                    <Typography color="blue-gray">
                      {persianNumberFormat(created_at.split(" ")[1])}
                    </Typography>

                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {type}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {field_title}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {branch_title}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {persianNumberFormat(total_price, true)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {persianNumberFormat(site_share, true)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {persianNumberFormat(vat_share, true)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {persianNumberFormat(agent_share, true)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex flex-col justify-center px-4">
                    <Typography color="blue-gray">
                      {person_name}
                    </Typography>
                    <Typography color="blue-gray">
                      {persianNumberFormat(person_phone)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex flex-col justify-center px-4">
                    <Typography color="blue-gray">
                      {agent_name}
                    </Typography>
                    <Typography color="blue-gray">
                      {persianNumberFormat(agent_phone)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {persianNumberFormat(person_national_code)}
                    </Typography>
                  </div>
                </td>


              </tr>
            );
          },
        )}
        </tbody>
      </table>
    </div>
  );
}